/**
 * Filters vehicles that do  not contain content (coming soon)
 *
 * @param {Object[]} vehicles
 * @return {Object[]}
 */
export function withoutCommingSoonModels(vehicles) {
  return vehicles.filter(x => !/comingsoon/.test(x.id)) // ID should contain "commingsoon" string
}
